import tokens from "@irati/auth/services/tokens"
import {toString as loginRefreshQuery} from "@irati/auth/services/queries/loginRefresh"

import internalLoginService from "@irati/auth-internal/services/login"
import sentry from "../../../sentry"
import graph from "../../../graph"
import GenericErrorCodes from "../../../errorCodes/Generic"
import domain from "../../../../env/domain"
import logout from "./logout"

export interface ErrorRequestLike {
  config: {[key: string]: any}
}

let inFlight: any = null

export default function (err?: ErrorRequestLike, accessToken?: string): Promise<any> {
  if (!tokens.hasResumed()) {
    // Condition just for native, web (through token.ts) will never reach this point
    inFlight = tokens.resume()
  }

  if (!inFlight) {
    if (!accessToken) {
      return logout(err)
    }
    inFlight = requestToken(accessToken)
  }

  return inFlight
    .catch((refreshError: any) => {
      sentry.captureException(refreshError)
      tokens.clear()
      return logout(err)
    })
    .finally((d: any) => {
      inFlight = null
      return d
    })
}

export function requestToken(accessToken: string) {
  if (domain.isInternal()) {
    return internalLoginService.refresh()
  }

  const variables = {
    expiredToken: accessToken
  }

  const options = {
    unAuth: true,
    useErrorHandler: false,
    sentryIgnoreError: [GenericErrorCodes.PBERRForbiddenTokenExpired]
  }

  return graph({query: loginRefreshQuery, variables, operationName: "loginRefresh"}, options).then((res) => {
    tokens.set({accessToken: res.loginRefresh.accessToken})
    return true
  })
}
